module.exports = __webpack_public_path__ + "static/media/banner-logado-mobile.fa561b58.webp";